var _config$media$mobile;

import { useState, useEffect } from 'react';
import { config } from '@grupoboticario/flora';
var mobileBp = parseFloat((_config$media$mobile = config.media.mobile) == null ? void 0 : _config$media$mobile.replace(/\D/g, ''));

var getInitialValue = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth <= mobileBp;
  }

  return false;
};

export var useIsMobile = () => {
  var [isMobile, setIsMobile] = useState(getInitialValue());
  var [observer, setObserver] = useState();
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setObserver(() => new window.ResizeObserver(_ref => {
        var [entry] = _ref;
        return setIsMobile(entry.contentRect.width <= mobileBp);
      }));
    }
  }, []);
  useEffect(() => {
    if (observer) {
      observer.observe(document.body);
      return () => observer.disconnect();
    }
  }, [observer]);
  return isMobile;
};
//# sourceMappingURL=useIsMobile.js.map